var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",class:{ 'full-chat': _vm.isChatPage }},[_c('div',{staticClass:"main-content"},[(!_vm.isChatPage)?_c('SidebarSystem'):_vm._e(),_c('div',{staticClass:"page-content"},[_c('transition',{attrs:{"name":"quick-fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }